<div class="row ng-scope">
  <div class="col-12">
    <div class="row form-group">
      <label class="control-label col-2">Mã</label>
      <div class="col-4">
        <input type="text" #mafocus [autofocus] tabIndex="1" class="form-control" placeholder="" [(ngModel)]="doituongSelect.Ma_Doi_Tuong">
      </div>
      <label class="control-label col-2 ng-binding">Cấp trên</label>
      <div class="col-4">
        <a *ngIf="doituongSelect.Parent===null" (click)="adddatachondoituongchung(1)" style="color:blue;font-weight:bold">
          <input id="99" tabindex="2" type="text" class="form-control" placeholder="Chọn cấp trên" [(ngModel)]="doituongSelect.Cha">
        </a>
        <a *ngIf="doituongSelect.Parent!==null" (dblclick)="adddatachondoituongchung(1)" style="color:blue;font-weight:bold">
          <input id="99" tabindex="2" type="text" class="form-control" placeholder="Chọn cấp trên" [(ngModel)]="doituongSelect.Cha" (ngModelChange)="adddatachondoituongchung(1)">
        </a>
        <!--<ng-select #slCapTren
             class="twcol"
             [tabIndex]="2"
             [openOnEnter]="false"
             [items]="inputparents"
             bindValue="Id"
             bindLabel="Ten_Doi_Tuong"
             notFoundText="Không có dữ liệu"
             [searchFn]="comboSearchFn"
             [(ngModel)]="doituongSelect.Parent">
    <ng-template ng-option-tmp let-item="item">

      <div class="rTableRow">
        <div class="rTableCell rTableCell-1">{{item.Ma_Doi_Tuong}}</div>
        <div class="rTableCell rTableCell-2">{{item.Ten_Doi_Tuong}}</div>
      </div>

    </ng-template>
  </ng-select>-->
      </div>

    </div>
    <div class="row form-group">
      <label class="control-label col-2 ng-binding">Tên</label>
      <div class="col-10">
        <input type="text" tabIndex="3" class="form-control" placeholder="" [(ngModel)]="doituongSelect.Ten_Doi_Tuong">
      </div>
    </div>

    <div class="row form-group">
      <label class="control-label col-2 ng-binding">Ngày ghi tăng</label>
      <div class="col-4">
        <kendo-dateinput style="width:100%;" tabIndex="4" [format]="'dd/MM/yyyy'" [(value)]="ngayghitang"></kendo-dateinput>
      </div>
      <label class="control-label col-2 ng-binding">Ngày KH, Thời gian KH</label>
      <div class="col-2">
        <kendo-dateinput style="width:100%;" tabIndex="5" [format]="'dd/MM/yyyy'" [(value)]="ngaykhauhao"></kendo-dateinput>
      </div>
      <div class="col-2">
        <input id="gia" #myinputsl class="form-control"
               maxlength="20"
               style="width:100%;"
               currencyMask
               [(ngModel)]="doituongSelect.Thoi_Gian_Khau_Hao"
               name="value"
               tabIndex="6"
               [placeholder]="''"
               [options]="ngxCurrencyOptions" autocomplete="off" />
      </div>

    </div>

    <div class="row form-group">
      <label class="control-label col-2">Loại tài sản</label>
      <div class="col-4">
        <ng-select #slLoaiTaiSan
                   class="twcol"
                   [tabIndex]="7"
                   [openOnEnter]="false"
                   [items]="inputloaitaisans"
                   bindValue="Id"
                   bindLabel="Ten_Doi_Tuong"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn"
                   [(ngModel)]="doituongSelect.Loai_Tai_San_Id">
          <ng-template ng-option-tmp let-item="item">

            <div class="rTableRow">
              <div class="rTableCell rTableCell-1">{{item.Ma_Doi_Tuong}}</div>
              <div class="rTableCell rTableCell-2">{{item.Ten_Doi_Tuong}}</div>
            </div>

          </ng-template>
        </ng-select>
      </div>
      <label class="control-label col-2 ng-binding">Phòng ban</label>
      <div class="col-4">
        <ng-select #slPhongban
                   class="twcol"
                   [tabIndex]="8"
                   [openOnEnter]="false"
                   [items]="inputphongbans"
                   bindValue="Id"
                   bindLabel="Ten_Doi_Tuong"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn"
                   [(ngModel)]="doituongSelect.Phong_Ban_Id">
          <ng-template ng-option-tmp let-item="item">

            <div class="rTableRow">
              <div class="rTableCell rTableCell-1">{{item.Ma_Doi_Tuong}}</div>
              <div class="rTableCell rTableCell-2">{{item.Ten_Doi_Tuong}}</div>
            </div>

          </ng-template>
        </ng-select>
      </div>

    </div>

    <div class="row form-group">
      <label class="control-label col-2">TK tài sản, chi phí, KH</label>
      <div class="col-4">
        <ng-select #slTK1
                   class="twcol"
                   [tabIndex]="9"
                   [openOnEnter]="false"
                   [items]="inputtaikhoans"
                   bindValue="Id"
                   bindLabel="Ma_Tai_Khoan"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFnTK"
                   style="width:33%;float:left"
                   [(ngModel)]="doituongSelect.TK_Tai_San_Id">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell rTableCell-1">{{item.Ma_Tai_Khoan}}</div>
              <div class="rTableCell rTableCell-2">{{item.Ten_Tai_Khoan}}</div>
            </div>
          </ng-template>
        </ng-select>
        <ng-select #slTK2
                   class="twcol"
                   [tabIndex]="10"
                   [openOnEnter]="false"
                   [items]="inputtaikhoans"
                   bindValue="Id"
                   bindLabel="Ma_Tai_Khoan"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFnTK"
                   style="width:33%;float:left"
                   [(ngModel)]="doituongSelect.TK_Chi_Phi_Id">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell rTableCell-1">{{item.Ma_Tai_Khoan}}</div>
              <div class="rTableCell rTableCell-2">{{item.Ten_Tai_Khoan}}</div>
            </div>
          </ng-template>
        </ng-select>
        <ng-select #slTK3
                   class="twcol"
                   [tabIndex]="11"
                   [openOnEnter]="false"
                   [items]="inputtaikhoans"
                   bindValue="Id"
                   bindLabel="Ma_Tai_Khoan"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFnTK"
                   style="width:33%;float:left"
                   [(ngModel)]="doituongSelect.TK_Khau_Hao_Id">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell rTableCell-1">{{item.Ma_Tai_Khoan}}</div>
              <div class="rTableCell rTableCell-2">{{item.Ten_Tai_Khoan}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>
      <label class="control-label col-2 ng-binding">Phương pháp KH</label>
      <div class="col-4">
        <ng-select #slPhuongphap
                   class="twcol"
                   [tabIndex]="12"
                   [openOnEnter]="false"
                   [items]="inputphuongphapkhauhaos"
                   bindValue="Id"
                   bindLabel="Ten_Doi_Tuong"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn"
                   [(ngModel)]="doituongSelect.Phuong_Phap_Khau_Hao">
          <ng-template ng-option-tmp let-item="item">

            <div class="rTableRow">
              <div class="rTableCell rTableCell-1">{{item.Ma_Doi_Tuong}}</div>
              <div class="rTableCell rTableCell-2">{{item.Ten_Doi_Tuong}}</div>
            </div>

          </ng-template>
        </ng-select>
      </div>

    </div>
    <div class="row form-group">
      <label class="control-label col-2">Xuất xứ, năm SX</label>
      <div class="col-4">
        <ng-select #slXuatXu
                   class="twcol"
                   [tabIndex]="13"
                   [openOnEnter]="false"
                   [items]="inputxuatxus"
                   bindValue="Id"
                   bindLabel="Ten_Doi_Tuong"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn"
                   style="width:60%;float:left"
                   [(ngModel)]="doituongSelect.Xuat_Xu_Id">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell rTableCell-1">{{item.Ma_Doi_Tuong}}</div>
              <div class="rTableCell rTableCell-2">{{item.Ten_Doi_Tuong}}</div>
            </div>
          </ng-template>
        </ng-select>
        <input id="gia" #myinputsl class="form-control"
               maxlength="20"
               style="width:39%;float:left"
               currencyMask
               [(ngModel)]="doituongSelect.Nam_San_Xuat"
               name="value"
               tabIndex="14"
               [placeholder]="''"
               [options]="ngxCurrencyOptions" autocomplete="off" />

      </div>
      <label class="control-label col-2 ng-binding">Đơn vị tính</label>
      <div class="col-4">
        <ng-select #slDonViTinh
                   class="twcol"
                   [tabIndex]="15"
                   [openOnEnter]="false"
                   [items]="inputdonvitinhs"
                   bindValue="Id"
                   bindLabel="Ten_Doi_Tuong"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn"
                   [(ngModel)]="doituongSelect.Don_Vi_Tinh_Id">
          <ng-template ng-option-tmp let-item="item">

            <div class="rTableRow">
              <div class="rTableCell rTableCell-1">{{item.Ma_Doi_Tuong}}</div>
              <div class="rTableCell rTableCell-2">{{item.Ten_Doi_Tuong}}</div>
            </div>

          </ng-template>
        </ng-select>
      </div>

    </div>

    <div class="row form-group">
      <label class="control-label col-2 ng-binding">Giá trị KH</label>
      <div class="col-4">
        <input id="gia" #myinputsl class="form-control"
               maxlength="20"
               style="width:100%;"
               currencyMask
               [(ngModel)]="doituongSelect.So_Tien"
               name="value"
               tabIndex="16"
               [placeholder]="''"
               [options]="ngxCurrencyOptions" autocomplete="off" />
      </div>
      <label class="control-label col-2 ng-binding">Ngày thôi KH</label>
      <div class="col-4">
        <kendo-dateinput style="width:100%;" tabIndex="17" [format]="'dd/MM/yyyy'" [(value)]="ngaythoikhauhao"></kendo-dateinput>
      </div>


    </div>

    <div class="row form-group">
      <label class="control-label col-2">Nguồn vốn</label>
      <div class="col-4">
        <ng-select #slNguonVon
                   class="twcol"
                   [tabIndex]="18"
                   [openOnEnter]="false"
                   [items]="inputnguonvons"
                   bindValue="Id"
                   bindLabel="Ten_Doi_Tuong"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn"
                   [(ngModel)]="doituongSelect.Nguon_Von_Id">
          <ng-template ng-option-tmp let-item="item">
            <div class="rTableRow">
              <div class="rTableCell rTableCell-1">{{item.Ma_Doi_Tuong}}</div>
              <div class="rTableCell rTableCell-2">{{item.Ten_Doi_Tuong}}</div>
            </div>
          </ng-template>
        </ng-select>
      </div>
      <label class="control-label col-2 ng-binding">Mã đơn vị</label>
      <div class="col-4">
        <ng-select #slMaDonVi
                   class="twcol"
                   [tabIndex]="19"
                   [openOnEnter]="false"
                   [items]="inputmadonvis"
                   bindValue="Id"
                   bindLabel="Ten_Doi_Tuong"
                   notFoundText="Không có dữ liệu"
                   [searchFn]="comboSearchFn"
                   [(ngModel)]="doituongSelect.Ma_Don_Vi_Id">
          <ng-template ng-option-tmp let-item="item">

            <div class="rTableRow">
              <div class="rTableCell rTableCell-1">{{item.Ma_Doi_Tuong}}</div>
              <div class="rTableCell rTableCell-2">{{item.Ten_Doi_Tuong}}</div>
            </div>

          </ng-template>
        </ng-select>
      </div>

    </div>

    <div class="row form-group">
      <label class="control-label col-2 ng-binding">Ghi chú</label>
      <div class="col-10">
        <textarea name="description" tabIndex="20" [(ngModel)]="doituongSelect.Ghi_Chu" placeholder="" type="text" class="form-control input-xs ng-pristine ng-untouched ng-valid ng-binding ng-empty" rows="3"> </textarea>
      </div>
    </div>

    <div class="row form-group">
      <div class="col-2">
        <label>
          <input tabIndex="50" type="checkbox" [(ngModel)]="doituongSelect.Tam_Dung_Khau_Hao" />
          <!--<span class="fa fa-check"></span>--> Tạm dừng khấu hao
        </label>
      </div>
      <div class="col-2">
        <label>
          <input tabIndex="51" type="checkbox" [(ngModel)]="doituongSelect.La_Tai_San" />
          <!--<span class="fa fa-check"></span>--> Là tài sản
        </label>
      </div>
      <div class="col-2">
        <label>
          <input tabIndex="52" type="checkbox" [(ngModel)]="doituongSelect.Khau_Hao_Chi_Tiet" />
          <!--<span class="fa fa-check"></span>--> Khấu hao chi tiết
        </label>
      </div>
      

    </div>



  </div>

</div>
<div class="modal-footer" style="display: flex;justify-content: space-between;">
  <div class="checkbox c-checkbox">
    <label>
      <!--<input tabIndex="5" type="checkbox" [(ngModel)]="doituongSelect.Trang_Thai" />
      <span class="fa fa-check"></span>{{hoatdong}}-->
    </label>
  </div>
  <div class="">
    <button class="mb-1 mr-1 btn btn-secondary" (click)="closeModal()" title="Ấn ESC để thoát" style="padding-top:0px !important">Hủy bỏ</button>
    <button *ngIf="!(quyen_sua==false && doituongSelect.Id!=null)" type="submit" (click)="saveproduct()" title="Ấn F9 để lưu" class="mb-1 mr-1 btn btn-primary" style="padding-top:0px !important">Lưu lại</button>
  </div>

</div>

<bs-modal #mdChonDoiTuongChung class="modal fade show in" [cssClass]="'modal800'" [backdrop]="'static'">
  <!--<div class="modal-header">
    <h4 class="modal-title">Thêm mới</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="mdChonDoiTuongChung.close()">
      <span aria-hidden="true">×</span>
    </button>
  </div>-->
  <bs-modal-body>
    <app-tonghop-chondoituongchung2edit #dtechondoituongchungedit (savect)="savedsdoituongchung($event)"></app-tonghop-chondoituongchung2edit>
  </bs-modal-body>
</bs-modal>
